import { useEffect, useRef, useState } from "react";

const DEFAULT_GOOGLE_WIDTH = 320;
const MAX_GOOGLE_WIDTH = 400;

export default function useResponsiveGoogleWidth(maxWidth = MAX_GOOGLE_WIDTH) {
  const containerRef = useRef(null);
  const [buttonWidth, setButtonWidth] = useState(DEFAULT_GOOGLE_WIDTH);

  useEffect(() => {
    const element = containerRef.current;
    if (!element) return undefined;

    const updateWidth = () => {
      const nextWidth = Math.max(
        180,
        Math.min(Math.floor(element.clientWidth || DEFAULT_GOOGLE_WIDTH), maxWidth)
      );
      setButtonWidth(nextWidth);
    };

    updateWidth();

    if (typeof ResizeObserver !== "undefined") {
      const observer = new ResizeObserver(updateWidth);
      observer.observe(element);

      return () => observer.disconnect();
    }

    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, [maxWidth]);

  return {
    containerRef,
    buttonWidth,
  };
}
